import ScenesListComponent from './ScenesList.component'

export default ScenesListComponent